import { postRequest } from 'utils/http'

export const verifyToken = payload => {
  return postRequest(`users/verify`, payload)
}

export const signup = payload => {
  return postRequest(`users/setup`, payload)
}
